import { render, staticRenderFns } from "./resourceLedgerAdd.vue?vue&type=template&id=7244c782&"
import script from "./resourceLedgerAdd.vue?vue&type=script&lang=js&"
export * from "./resourceLedgerAdd.vue?vue&type=script&lang=js&"
import style0 from "./resourceLedgerAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports